import type { TransactionFilters } from '../../../__generated__/globalTypes';

/** Rows the section shows. */
export const RECENT_TRANSACTIONS_VISIBLE_COUNT = 3;

/** One more than shown, so dropping the page's own record still leaves a full list. */
export const RECENT_TRANSACTIONS_FETCH_LIMIT = RECENT_TRANSACTIONS_VISIBLE_COUNT + 1;

export interface IRecentTransactionsScope {
  merchantId?: string | null;
  recurringTransactionId?: string | null;
}

/**
 * A stream's payments are already the merchant's, so the stream id alone
 * scopes the read; otherwise everything at the merchant counts, refunds
 * included — this is a list, not a spend total.
 */
export function buildRecentTransactionsFilters({
  merchantId,
  recurringTransactionId,
}: IRecentTransactionsScope): TransactionFilters {
  if (recurringTransactionId) {
    return { recurringTransactionId };
  }
  return { merchantIds: merchantId ? [merchantId] : [] };
}

/** The newest rows other than the page's own record, capped at the visible count. */
export function selectRecentTransactions<T extends { id: string }>(
  transactions: readonly T[],
  excludeTransactionId?: string | null
): T[] {
  return transactions
    .filter((transaction) => transaction.id !== excludeTransactionId)
    .slice(0, RECENT_TRANSACTIONS_VISIBLE_COUNT);
}
